module.exports = __webpack_public_path__ + "static/media/InfoISmallcon.d9d93ab7.svg";